export default {
  ledger: "profile/ledger",
  invoice: (no) => `billing/proforma/${atob(no)}`,
  receipt: (no) => `billing/receipt/${no}`,
  balance: `billing/balance`,
};
